const ENABLED_ENV_LIST = ["local", "develop", "test"];
const VCONSOLE_QUERY_KEY = "vconsole";

type VConsoleInstance = {
  destroy: () => void;
};

declare global {
  interface Window {
    __SEAME_VCONSOLE__?: VConsoleInstance;
  }
}

const isQueryEnabled = (value: string | null) => {
  if (!value) return null;

  const normalizedValue = value.toLowerCase();

  if (["1", "true", "yes"].includes(normalizedValue)) return true;
  if (["0", "false", "no"].includes(normalizedValue)) return false;

  return null;
};

const shouldEnableVConsole = () => {
  const runtimeConfig = useRuntimeConfig();
  const queryValue = new URLSearchParams(window.location.search).get(
    VCONSOLE_QUERY_KEY,
  );
  const queryEnabled = isQueryEnabled(queryValue);

  if (queryEnabled !== null) return queryEnabled;

  return ENABLED_ENV_LIST.includes(String(runtimeConfig.public.NUXT_ENV));
};

export default defineNuxtPlugin(async () => {
  if (!shouldEnableVConsole() || window.__SEAME_VCONSOLE__) return;

  const { default: VConsole } = await import("vconsole");
  window.__SEAME_VCONSOLE__ = new VConsole({
    theme: "light",
  });
});
